import path from 'node:path';
import { componentGenerator } from '@wix/gena';
import type { Component } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { ComponentType } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { getExtensionPath } from '@wix/cli-astro-definitions';

const EVENT_TEMPLATE = path.resolve(__dirname, '../templates/astro/event');

export async function generateEvent(projectFolder: string, folderName: string) {
  const component: Component = {
    compName: 'wix.contacts.v4.contact_created',
    compId: randomUUID(),
    compType: ComponentType.WEBHOOK,
    compData: {
      webhook: {
        webhookSlug: 'wix.contacts.v4.contact_created',
      },
    },
  };

  const eventConfigJSON = toJsonString(component, { spaces: 2 });
  const cwd = getExtensionPath(projectFolder, folderName);

  return await componentGenerator({
    template: EVENT_TEMPLATE,
    cwd,
    projectFolder,
    data: {
      eventConfigJSON,
    },
  });
}
